import React, { Component } from 'react';
import { connect } from 'react-redux';

import Dim from 'web/components/common/modal/common/Dim';

import EventPopup from 'shared/components/popup/EventPopup';

import { getCookie } from 'shared/utils/cookie';
import { initModal, pushModal } from 'shared/actions/modal.action';
import { pushToastApp } from 'shared/actions/toast.action';

@connect(
  (state, props) => ({
    data: state.shared.modal.data,
  }),
  { initModal, pushModal, pushToastApp },
)
class EventPopupContainer extends Component {
  handleClose = () => {
    return this.props.initModal();
  };
  handleSubmit = () => {
    const popup_cookie = getCookie('nsda_cupon');
    console.log({});
    if (popup_cookie) {
      this.props.initModal();
      this.props.pushToastApp({ message: '이미 적용되었습니다.' });
    } else {
      this.props.pushModal({
        type: 'NsdaCuponCompleteContainer',
      });
    }
  };
  render() {
    const { data = {} } = this.props;

    return (
      <Dim>
        <EventPopup
          img={`https://image.okaydoctor.co.kr/image/m-popup-img_300px-1127.png`}
          pcImg={`https://image.okaydoctor.co.kr/image/pc-popup-img.png`}
          handlePopupClose={this.handleClose}
          handleSubmit={this.handleSubmit}
          date={data.date}
        />
      </Dim>
    );
  }
}

export default EventPopupContainer;
